import {ResponseError} from "@globals/types/utilityTypes";

const commonErrorMessage = "Ooops! Something went wrong";

export function formatFormError(error: ResponseError): string {
  if (!error) return commonErrorMessage;
  switch (error.status) {
    case 496:
    case 473:
      return error.message ?? commonErrorMessage;
    case 400:
      return "Please submit all required fields.";
    default:
      // any other issue
      return commonErrorMessage;
  }
}

export function formatLocationsError(error: Error): string {
  return error.message || commonErrorMessage;
}
